/** Full locale hi (Hindi, Devanagari) – edit as needed. */
export default {
  'nav.home': 'होम',
  'nav.seeDemo': 'डेमो देखें',
  'nav.howItWorks': 'कैसे काम करता है',
  'nav.pricing': 'मूल्य निर्धारण',
  'nav.aboutUs': 'हमारे बारे में',
  'nav.faqs': 'पूछे जाने वाले प्रश्न',
  'nav.contact': 'संपर्क करें',
  'nav.blog': 'ब्लॉग',
  'nav.logIn': 'लॉग इन / साइन अप',
  'nav.getStarted': 'शुरू करें',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'केवल $2/माह से शुरू!',
  'hero.oneAgreement': 'बस 1 एग्रीमेंट पर साइन? केवल $6 प्रीमियम फ़ीचर्स के साथ – सदस्यता नहीं चाहिए।',
  'hero.subscriptionsOnly': '( केवल सदस्यता )',
  'hero.couponBannerText': 'हमारे पहले 1000 उपयोगकर्ताओं के लिए आजीवन 10% छूट कूपन कोड!',
  'hero.couponSubscribedOnly': '(केवल सदस्यता लेने वाले)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'ई-हस्ताक्षर प्लेटफ़ॉर्म · योजनाएँ $2/माह से',
  'hero.bannerHeadlinePrefix': 'तुरंत पाएँ अपने',
  'hero.bannerHeadlineMid': 'पर हस्ताक्षर',
  'hero.bannerHeadlineAccent': 'किए हुए।',
  'hero.bannerCycleContracts': 'अनुबंध',
  'hero.bannerCycleNDAs': 'NDA',
  'hero.bannerCycleProposals': 'प्रस्ताव',
  'hero.bannerCycleDocuments': 'दस्तावेज़',
  'hero.bannerDesc':
    'प्रोफ़ेशनल समझौते बनाएं, ई-हस्ताक्षर भेजें, और कानूनी रूप से बाध्यकारी हस्ताक्षरित PDF मिनटों में पाएं — किसी भी डिवाइस से।',
  'hero.watchDemo': 'देखें यह कैसे काम करता है',
  'hero.trustLocked': 'AES-256 एन्क्रिप्शन',
  'hero.trustNoCard': 'कार्ड की जरूरत नहीं',
  'hero.trustReady': '२ मिनट में शुरू',
  'hero.landingShowMore': 'और दिखाएँ',
  'hero.landingShowLess': 'कम दिखाएँ',
  'hero.tagline': 'दस्तावेज़ बनाने, हस्ताक्षर करने और भेजने का सबसे आसान तरीका — बिना लॉक-इन',
  'hero.firebaseTopAria': 'सुरक्षा और होस्टिंग (Google Firebase व Google Cloud)',
  'hero.topTrustListAria': 'सुरक्षा, मूल्य निर्धारण, हस्ताक्षर, रिमाइंडर और सहायता',
  'hero.accDataSafeTitle': 'आपका डेटा हमारे पास सुरक्षित है',
  'hero.accDataSafe1':
    'Google Firebase और Google Cloud पर चलता है — वही एंटरप्राइज़-ग्रेड इंफ़्रास्ट्रक्चर जिस पर लाखों ऐप भरोसा करते हैं',
  'hero.accDataSafe2':
    'आपका डेटा AES-256 एन्क्रिप्शन से सुरक्षित है, Google-प्रबंधित कुंजियों के साथ',
  'hero.accDataSafe3':
    'Google के अग्रणी सुरक्षा मानकों पर आधारित प्रमाणीकरण और डेटा हैंडलिंग',
  'hero.accDataSafe4': 'हम आपका डेटा न बेचते हैं न साझा करते हैं — गोपनीयता का सम्मान हमेशा',
  'hero.accDataSafe5Before': 'डेटा संग्रहण और उपयोग पर पूरी पारदर्शिता (हमारी ',
  'hero.accDataSafe5After': ' देखें)',
  'hero.accPricingTitle': 'सरल, सस्ती कीमतें — कोई छुपी फीस नहीं',
  'hero.accPricing1': 'मिनटों में प्रोफ़ेशनल समझौते बनाएं',
  'hero.accPricing2': 'योजनाएँ मात्र $2 प्रति माह से',
  'hero.accPricing3': 'कोई छुपी फीस या अप्रत्याशित शुल्क नहीं',
  'hero.accPricing4': 'कोई लॉक-इन नहीं — कभी भी रद्द करें',
  'hero.accPricing5': 'फ्रीलांसर, स्टार्टअप और छोटे व्यवसायों के लिए उपयुक्त',
  'hero.accPricing6': 'शुरुआत के लिए अपना पहला दस्तावेज़ मुफ्त भेजें',
  'hero.accSigningTitle': 'तेज़ और आसान डॉक्युमेंट साइनिंग',
  'hero.accSigning1': '30+ तैयार टेम्पलेट चुनें या अपनी फ़ाइल अपलोड करें',
  'hero.accSigning2': 'सेकंडों में हस्ताक्षर फ़ील्ड जोड़ें और अनुकूलित करें',
  'hero.accSigning3': 'एक साथ कई प्राप्तकर्ताओं को भेजें',
  'hero.accSigning4': 'टेम्पलेट सहेजें और दोबारा उपयोग करें',
  'hero.accSigning5': 'प्राप्तकर्ताओं को खाते की जरूरत नहीं — तुरंत हस्ताक्षर',
  'hero.accSigning6': 'भेजने से पहले लाइव प्रीव्यू से सब कुछ सही दिखे',
  'hero.accRemindersTitle': 'स्मार्ट रिमाइंडर और ट्रैकिंग',
  'hero.accReminders1': '1, 3 और 7 दिनों पर स्वचालित फॉलो-अप',
  'hero.accReminders2': 'दस्तावेज़ खुलने या हस्ताक्षर पर तुरंत सूचना',
  'hero.accReminders3': 'पूरी साइनिंग प्रक्रिया रीयल-टाइम में देखें',
  'hero.accReminders4': 'हस्ताक्षर के लिए फिर से मैन्युअली न पूछें',
  'hero.accAnywhereTitle': 'कहीं से भी काम करें',
  'hero.accAnywhere1': 'डेस्कटॉप या मोबाइल पर दस्तावेज़ खोलें',
  'hero.accAnywhere2': 'किसी भी डिवाइस से भेजें और हस्ताक्षर करें',
  'hero.accAnywhere3': 'लचीला — ऑफिस में हों या चलते-फिरते',
  'hero.accSupportTitle': 'विश्वसनीय सहायता',
  'hero.accSupport1': 'तेज़ जवाबों के साथ समर्पित ग्राहक सहायता',
  'hero.accSupport2': 'लक्ष्य: 24 घंटे के भीतर सभी प्रश्नों का जवाब',
  'hero.accSupport3': 'यूज़र फीडबैक पर आधारित लगातार अपडेट',
  'hero.firebaseTrustPrivacyLink': 'गोपनीयता नीति',
  'hero.firebaseTrustFineprintAfter':
    ' आपके डेटा रिटेंशन, पहुंच और अधिकारों की व्याख्या करती है। हम आपका डेटा कभी नहीं बेचते।',
  'hero.pill': 'सेकंडों में कानूनी रूप से बाध्यकारी ई-हस्ताक्षर भेजें',
  'hero.headline': 'फ्रीलांसर्स और छोटी टीमों के लिए सबसे सरल ई-हस्ताक्षर टूल',
  'hero.ctaPrimary': 'दस्तावेज़ बनाएं / अपलोड करें और हस्ताक्षर के लिए भेजें',
  'hero.ctaTrialSignup': '1 माह के मुफ्त ट्रायल के साथ अभी आज़माएँ',
  'hero.ctaFreeDocument': 'अभी एक मुफ्त दस्तावेज़ आज़माएँ',
  'hero.ctaPrimaryNote': 'क्रेडिट कार्ड या भुगतान विवरण आवश्यक नहीं।',
  'hero.subscriptionTeaserBefore': 'सब्सक्रिप्शन मात्र ',
  'hero.subscriptionTeaserAfter': ' प्रति माह से!',
  'hero.createAccountTrialHeadline': 'अभी साइन अप करें और 1 महीने का मुफ्त ट्रायल पाएं',
  'hero.createAccountPromoCopy': 'कोड कॉपी करें',
  'hero.createAccountPromoCopied': 'कॉपी हो गया!',
  'hero.createAccountPromoCodeAria': 'प्रोमो कोड: एक महीने का मुफ्त ट्रायल',
  'hero.createAccountNote': 'प्लान चुनते समय चेकआउट पर इसे लगाएँ।',
  'hero.createAccountOfferLimit': '( ऑफ़र केवल हमारे पहले 1000 उपयोगकर्ताओं के लिए मान्य )',
  'hero.desc': 'आधुनिक हस्ताक्षर अनुभव के साथ समझौते बनाएं, भेजें और ट्रैक करें।',
  'hero.getStartedFree': 'मुफ्त शुरू करें',
  'hero.tryWithoutAccountButton': 'बिना खाता आज़माएं',
  'hero.logInSignUp': 'लॉग इन / साइन अप',
  'hero.whyChooseUs': 'हम क्यों चुनें?',
  'hero.stepsTitle': 'बनाएं, हस्ताक्षर करें, प्राप्त करें',
  'hero.stepsSubtitle': 'तीन आसान चरणों में दस्तावेज़ बनाएं और मिनटों में हस्ताक्षर करवाएं।',
  'hero.step1Create': 'अपना दस्तावेज़ अपलोड या बनाएं',
  'hero.step2Sign': 'हस्ताक्षर के लिए भेजें',
  'hero.step3Receive': 'हस्ताक्षर होते ही तुरंत सूचना पाएं',
  'hero.benefit1': 'आसान – सेकंडों में साइन लिंक और ईमेल भेजें',
  'hero.benefit2': 'मौजूदा PDF अपलोड करें या टेक्स्ट निकालें और रिच टेक्स्ट से संपादित करें',
  'hero.benefit3': 'PDF से टेक्स्ट निकालें और संपादित करें',
  'hero.benefit4': 'सेकंडों में साइन फ़ील्ड और लेआउट बनाएं',
  'hero.benefit5': 'एक साथ कई प्राप्तकर्ताओं को भेजें',
  'hero.benefit6': 'सब्सक्राइब करने की ज़रूरत नहीं – प्रति भेजना भुगतान',
  'hero.benefit7': 'लिंक कॉपी करके किसी को भी भेजें',
  'hero.benefit8': 'टेम्पलेट बनाएं और सहेजें',
  'hero.benefit9': 'सभी ईमेल इवेंट देखें',
  'hero.benefit10': 'लाइव प्रीव्यू और ऑडिट-तैयार PDF',
  'hero.benefit11': 'लचीले संपादन वाले टेम्पलेट',
  'hero.benefit12': 'प्राप्तकर्ताओं को साइनअप की ज़रूरत नहीं',
  'hero.benefit13': 'किसी भी डिवाइस पर काम करता है',
  'how.simpleProcess': 'सरल प्रक्रिया',
  'how.title': 'कैसे काम करता है',
  'how.subtitle': 'तीन चरणों में बनाएं, भेजें और साइन करें।',
  'how.step1Title': 'टेम्पलेट बनाएं',
  'how.step1Desc': 'PDF एक्सट्रैक्ट/अपलोड, टेक्स्ट एडिटर, साइन फ़ील्ड (तारीख, नाम, नियम, साइन ब्लॉक), लेआउट। टेम्पलेट के रूप में सहेजें और दोबारा इस्तेमाल करें।',
  'how.step2Title': 'प्राप्तकर्ताओं को भेजें',
  'how.step2Desc': 'सुरक्षित, अद्वितीय साइन लिंक के साथ ईमेल से दस्तावेज़ भेजें। कई प्राप्तकर्ता, लिंक कॉपी करें, खुलने और पूर्ण होने को ट्रैक करें।',
  'how.step3Title': 'हस्ताक्षरित PDF प्राप्त करें',
  'how.step3Desc': 'पूर्ण ऑडिट ट्रेल के साथ हस्ताक्षरित PDF प्राप्त करें: टाइमस्टैंप, ईमेल, फ़ोन, सहमति। पूर्ण होने पर कन्फर्मेशन ईमेल।',
  'pricing.compareHeadline': 'ई-हस्ताक्षर के लिए $19/माह क्यों दें?',
  'pricing.comparePlatform': 'प्लेटफ़ॉर्म',
  'pricing.comparePrice': 'मूल्य',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/माह',
  'pricing.compareBestValue': 'सर्वोत्तम मूल्य',
  'pricing.compareWhyPayLine1': 'सेकंडों में कानूनी रूप से बाध्यकारी ई-हस्ताक्षर भेजें',
  'pricing.compareWhyPayLine2': 'एक से ज़्यादा भेजना है? सब्सक्रिप्शन $2 प्रति माह से',
  'pricing.compareBenefitSingle': 'एकल दस्तावेज़ भेजें',
  'pricing.compareBenefitNoContract': 'कोई महँगे अनुबंध नहीं',
  'pricing.compareBenefitPayWhenNeed': 'जब ज़रूरत हो तभी भुगतान करें',
  'pricing.compareBenefitTemplates': '30 से अधिक टेम्पलेट में से चुनें',
  'pricing.compareDisclaimer': 'प्रतिस्पर्धी कीमतें सार्वजनिक स्टार्टर प्लान पर आधारित; भिन्न हो सकती हैं।',
  'trust.secureLinks': 'हर दस्तावेज़ के लिए अद्वितीय, सुरक्षित हस्ताक्षर लिंक',
  'trust.auditTrail': 'हर हस्ताक्षर पर पूर्ण ऑडिट ट्रेल (कौन, कब, IP)',
  'trust.verifiablePdfs': 'सत्यापन योग्य हस्ताक्षरित PDF जिन्हें आप रख सकते हैं',
  'trust.footer': 'दुनिया भर में फ्रीलांसर्स और छोटे व्यवसायों द्वारा विश्वसनीय',
  'useCases.title': 'इनके लिए आदर्श ( टेम्पलेट तैयार )',
  'useCases.freelancers': 'फ्रीलांसर्स जो अनुबंध भेजते हैं',
  'useCases.agencies': 'एजेंसियां जो समझौते पर हस्ताक्षर करती हैं',
  'useCases.landlords': 'मकान मालिक जो लीज़ भेजते हैं',
  'useCases.startups': 'स्टार्टअप जो NDA पर हस्ताक्षर करते हैं',
  'useCases.carBoat': 'कानूनी दस्तावेज़ के साथ कार या नाव बेचें',
  'useCases.consultants': 'सलाहकार और स्वतंत्र',
  'useCases.equipmentRental': 'औपचारिक समझौते के साथ उपकरण किराए पर देना',
  'useCases.contractors': 'स्वतंत्र ठेकेदार ग्राहक कार्य को औपचारिक रूप दें',
  'useCases.website': 'वेबसाइट और डिजिटल परियोजना समझौते',
  'pricing.title': 'मूल्य निर्धारण',
  'pricing.billAnnually': 'वार्षिक बिलिंग',
  'pricing.billMonthly': 'मासिक बिलिंग',
  'pricing.getStarted': 'शुरू करें',
  'pricing.mostPopular': 'सबसे लोकप्रिय',
  'pricing.billedPerYear': '${amount}/वर्ष',
  'pricing.perMonth': '/माह',
  'pricing.tierBasic': 'बेसिक',
  'pricing.tierStandard': 'स्टैंडर्ड',
  'pricing.tierPremium': 'प्रीमियम',
  'pricing.descBasic': 'कभी-कभी उपयोग के लिए।',
  'pricing.descStandard': 'बढ़ती टीमों के लिए।',
  'pricing.descPremium': 'उन्नत ज़रूरतों वाले यूज़र्स के लिए।',
  'about.label': 'हम क्यों चुनें',
  'about.title': 'हमारे बारे में',
  'about.subtitle': 'हम साइनिंग वर्कफ़्लो को सरल, तेज़ और सुरक्षित बनाते हैं।',
  'about.speed': 'गति',
  'about.builtForSpeed': 'गति के लिए बनाया गया',
  'about.builtForSpeedDesc': 'आधुनिक UI से मिनटों में दस्तावेज़ बनाएं और भेजें। किसी भी डिवाइस से साइन करें।',
  'about.security': 'सुरक्षा',
  'about.dataSecurity': 'डेटा सुरक्षा',
  'about.dataSecurityTitle': 'Google Firebase और Google Cloud पर होस्ट किया गया',
  'about.dataSecurityDesc': 'आपका खाता डेटा, दस्तावेज़, टेम्पलेट और साइनिंग गतिविधि Google Firebase और Google Cloud पर संसाधित होती है—ऐसे प्लेटफ़ॉर्म जो मजबूत प्रमाणीकरण और स्टोरेज चाहने वाले प्रोडक्शन ऐप्स के लिए बनाए गए हैं। ट्रैफ़िक एंड-टू-एंड HTTPS (TLS) का उपयोग करता है; आराम पर डेटा Google-प्रबंधित कुंजियों (AES-256 सहित) से एन्क्रिप्ट होता है। साइन-इन Firebase Authentication से चलते हैं, और Firestore सुरक्षा नियम यह सुनिश्चित करने में मदद करते हैं कि पढ़ना-लिखना आपके खाते से मेल खाए, ताकि आपका वर्कस्पेस अलग रहे और पूरी दुनिया के लिए पढ़ने योग्य न हो। स्टैक Google के वैश्विक नेटवर्क पर चलता है, निगरानी, पैचिंग और विश्वसनीयता के अभ्यास Google के दस्तावेज़ में वर्णित हैं; हम आपके निजी डेटा या दस्तावेज़ सामग्री को दलालों या विज्ञापनदाताओं को नहीं बेचते। उप-प्रोसेसर, अनुपालन कार्यक्रम और आपके अधिकारों के लिए हमारी गोपनीयता नीति देखें।',
  'about.dataSecurityPrivacyCta': 'पूरी गोपनीयता नीति पढ़ें →',
  'about.privacyPill': 'गोपनीयता',
  'about.privacyFocused': 'गोपनीयता केंद्रित',
  'about.privacyFocusedDesc': 'हर साइन लिंक अद्वितीय है—प्राप्तकर्ता केवल वही देखते हैं जो आप भेजते हैं। हस्ताक्षरित PDFs में स्पष्ट ऑडिट ट्रेल होती है जिसे आप संग्रह कर सकते हैं: किसने साइन किया, कब, और क्या सहमति दी, ताकि गोपनीयता और प्रमाण साथ रहें।',
  'about.teams': 'व्यक्ति और टीमें',
  'about.madeForTeams': 'व्यक्तियों और टीमों के लिए',
  'about.madeForTeamsDesc': 'टेम्पलेट से आसान: टेक्स्ट, हेडिंग, लिस्ट, साइन फ़ील्ड, तारीख, नाम, कस्टम फ़ील्ड। टेम्पलेट सहेजें और दोबारा इस्तेमाल करें।',
  'about.sectionHeadlineBefore': 'विश्वास और गति के लिए ',
  'about.sectionHeadlineAccent': 'बनाया गया',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'पूछे जाने वाले प्रश्न',
  'faq.searchHint': 'किसी भी कीवर्ड से FAQs तुरंत खोजें',
  'faq.searchPlaceholder': 'जैसे PDF, टेम्पलेट, साइन...',
  'faq.noResults': 'आपकी खोज से कोई FAQ मेल नहीं खाता। दूसरे कीवर्ड आज़माएं।',
  'faq.more': 'अधिक',
  'faq.less': 'कम',
  'faq.eyebrow': 'प्रश्न हैं?',
  'faq.titleBefore': 'अक्सर पूछे जाने वाले ',
  'faq.titleAccent': 'प्रश्न',
  'faq.subtitleLead': 'Prime Document Sign के बारे में जो कुछ जानना ज़रूरी है। जवाब नहीं मिला? ',
  'faq.subtitleLink': 'हमसे संपर्क करें।',
  'faq.clearSearchAria': 'खोज साफ़ करें',
  'faq.subscriptionsWorkQ': 'सब्सक्रिप्शन कैसे काम करते हैं?',
  'faq.subscriptionsWorkA': 'प्रीमियम प्लान (${{monthly}} $/माह या ${{annual}} $/वर्ष)। प्रति भेजना भुगतान भी। Stripe के ज़रिए बिल। मेरा खाता → मेरी सब्सक्रिप्शन में प्रबंधित करें।',
  'faq.upgradePlanQ': 'प्लान कैसे अपग्रेड करें?',
  'faq.upgradePlanA': 'मेरा खाता → मेरी सब्सक्रिप्शन, उच्च टियर चुनें और कन्फर्म करें। अपग्रेड आमतौर पर तुरंत।',
  'faq.downgradePlanQ': 'प्लान कैसे डाउनग्रेड करें?',
  'faq.downgradePlanA': 'मेरा खाता → मेरी सब्सक्रिप्शन, निचला टियर चुनें। अगले बिलिंग चक्र की शुरुआत में लागू।',
  'faq.cancelPlanQ': 'सब्सक्रिप्शन कैसे रद्द करें?',
  'faq.cancelPlanA': 'मेरा खाता → मेरी सब्सक्रिप्शन, Stripe पोर्टल से रद्द करें या सपोर्ट से संपर्क करें। रद्दीकरण वर्तमान अवधि के अंत में लागू।',
  'faq.oneTimeOptionQ': 'प्रति भेजना भुगतान क्या है?',
  'faq.oneTimeOptionA': 'कभी-कभी भेजने के लिए: ${{oneTimePrice}} $ प्रति भेजना सब्सक्राइब करने के बजाय। उस भेजने के लिए पूर्ण प्रीमियम फ़ीचर। साइनअप या मेरी सब्सक्रिप्शन में चुनें।',
  'faq.emailLimitQ': 'मासिक ईमेल लिमिट पर क्या होगा?',
  'faq.emailLimitA': 'बेसिक: 5 ईमेल/माह, स्टैंडर्ड: 50, प्रीमियम: 150। लिमिट हर महीने रिसेट। लिमिट पर: टॉप अप या अपग्रेड।',
  'faq.yearlyBillingQ': 'वार्षिक बिलिंग?',
  'faq.yearlyBillingA': 'हाँ। प्रीमियम: ${{monthly}} $/माह या ${{annual}} $/वर्ष। वार्षिक से {{discountPercent}}% तक बचत। मेरी सब्सक्रिप्शन में बदलें।',
  'faq.multipleRecipientsQ': 'कई प्राप्तकर्ता?',
  'faq.multipleRecipientsA': 'हाँ। बेसिक: 5 तक, स्टैंडर्ड और प्रीमियम: 10 तक। ईमेल कॉमा से अलग। हर कोई अद्वितीय लिंक। खाता ज़रूरी नहीं।',
  'faq.reuseTemplatesQ': 'टेम्पलेट दोबारा इस्तेमाल कर सकते हैं?',
  'faq.reuseTemplatesA': 'बेसिक: 3, स्टैंडर्ड: 10, प्रीमियम: 25 टेम्पलेट। टेम्पलेट हिस्ट्री (मेरा खाता) से लोड करें।',
  'faq.recipientAccountQ': 'क्या प्राप्तकर्ता को खाता चाहिए?',
  'faq.recipientAccountA': 'नहीं। प्राप्तकर्ता को ईमेल में लिंक मिलता है और डिवाइस से साइन कर सकता है। खाता ज़रूरी नहीं। डेस्कटॉप, टैबलेट, मोबाइल।',
  'faq.confirmationEmailQ': 'कन्फर्मेशन ईमेल मिलेगा?',
  'faq.confirmationEmailA': 'हाँ। पूर्ण होने पर ईमेल के साथ हस्ताक्षरित PDF। हर PDF में ऑडिट ट्रेल।',
  'faq.previewPdfQ': 'भेजने से पहले PDF प्रीव्यू?',
  'faq.previewPdfA': 'हाँ। लेआउट देखने के लिए प्रीव्यू PDF बटन। फिर भेजें या लिंक कॉपी करें।',
  'faq.editAgreementQ': 'समझौता टेक्स्ट संपादित कर सकते हैं?',
  'faq.editAgreementA': 'हाँ। टेक्स्ट एडिटर से हेडिंग, लिस्ट, बोल्ड, इटैलिक। PDF अपलोड करके एक्सट्रैक्ट या दिखाएं।',
  'faq.signatureRequiredQ': 'सबमिट के लिए साइन ज़रूरी?',
  'faq.signatureRequiredA': 'हाँ। प्राप्तकर्ताओं को तारीख, पूरा नाम, नियम चेकबॉक्स और साइन भरना होगा। कानूनी वैधता।',
  'faq.attachmentsQ': 'कितने अटैचमेंट?',
  'faq.attachmentsA': 'बेसिक: कोई नहीं। स्टैंडर्ड: 3 (8 MB कुल)। प्रीमियम: 10 (8 MB कुल)। साइन लिंक के साथ भेजे जाते हैं।',
  'faq.emailActivityQ': 'ईमेल गतिविधि (प्रीमियम)?',
  'faq.emailActivityA': 'प्रीमियम: मेरा खाता में ईमेल गतिविधि। कौन से दस्तावेज़, कब, किसे। अनुपालन।',
  'faq.emailRemindersQ': 'ईमेल रिमाइंडर कैसे काम करते हैं?',
  'faq.emailRemindersA': 'दस्तावेज़ बिल्डर में चरण 4 (अतिरिक्त सुविधाएँ) पर आप हर भेजने के लिए 1, 3 और/या 7 दिन के रिमाइंडर चालू कर सकते हैं। पहला साइनिंग ईमेल जाने के बाद, हम केवल तभी रिमाइंडर भेजते हैं जब वह प्राप्तकर्ता अभी तक दस्तावेज़ पूरा नहीं कर चुका। साइन करते ही रिमाइंडर अपने आप बंद हो जाते हैं। रिमाइंडर ईमेल गतिविधि में तारीख-समय के साथ दिखते हैं; ये आपकी मासिक ईमेल सीमा में नहीं गिने जाते।',
  'faq.defaultSenderQ': 'डिफ़ॉल्ट सेंडर ईमेल?',
  'faq.defaultSenderA': 'मेरा खाता → खाता विवरण, ईमेल दर्ज करें और सहेजें। भेजते समय ऑटो-भर जाएगा।',
  'faq.mobileSignQ': 'मोबाइल पर साइन कर सकते हैं?',
  'faq.mobileSignA': 'हाँ। रिस्पॉन्सिव अनुभव। स्मार्टफ़ोन/टैबलेट पर लिंक खोलें, उंगली या स्टाइलस से साइन करें।',
  'faq.getHelpQ': 'मदद कैसे लें?',
  'faq.getHelpA': 'मेरा खाता में सपोर्ट या संपर्क फ़ॉर्म। जल्द जवाब देंगे।',
  'faq.dataSecureQ': 'क्या मेरा डेटा सुरक्षित है?',
  'faq.dataSecureA': 'हाँ। दस्तावेज़ और जानकारी की सुरक्षा के लिए मानक प्रथाएं।',
  'faq.fileFormatsQ': 'कौन से फ़ाइल फॉर्मैट?',
  'faq.fileFormatsA': 'दस्तावेज़ टेक्स्ट एडिटर में बनाए जाते हैं। पूर्ण समझौते PDF में।',
  'faq.deleteTemplateQ': 'टेम्पलेट डिलीट करने पर क्या होगा?',
  'faq.deleteTemplateA': 'डिलीट किए गए टेम्पलेट स्थायी रूप से हट जाते हैं। डिलीट से पहले सुनिश्चित करें। कभी भी नया टेम्पलेट बना सकते हैं।',
  'faq.ownLogoQ': 'अपना लोगो जोड़ सकते हैं?',
  'faq.ownLogoA': 'हाँ, स्टैंडर्ड और प्रीमियम प्लान पर। लोगो (20 KB तक) अपलोड करें और पोजिशन चुनें। बेसिक में नहीं।',
  'faq.uploadPdfQ': 'PDF कैसे अपलोड करें?',
  'faq.uploadPdfA': 'डॉक्यूमेंट बिल्डर में अपलोड PDF विकल्प (स्टैंडर्ड और प्रीमियम) इस्तेमाल करें। आपका PDF समझौता टेक्स्ट के ऊपर या बगल में दिखेगा। प्राप्तकर्ता साइन करते समय पूरा दस्तावेज़ देख सकते हैं।',
  'faq.extractPdfQ': 'PDF एक्सट्रैक्शन क्या है और कैसे काम करता है?',
  'faq.extractPdfA': 'PDF एक्सट्रैक्शन (स्टैंडर्ड और प्रीमियम) मौजूदा PDF से टेक्स्ट निकालकर एडिटर में संपादित करने देता है। PDF अपलोड करें, टेक्स्ट निकालें चुनें, कंटेंट कॉपी हो जाएगा। फिर संपादित करें और साइन फ़ील्ड जोड़ें।',
  'faq.richTextEditorQ': 'रिच टेक्स्ट एडिटर से क्या कर सकते हैं?',
  'faq.richTextEditorA': 'रिच टेक्स्ट एडिटर से हेडिंग, बोल्ड, इटैलिक, लिस्ट, फॉन्ट साइज़ के साथ समझौते बना और फॉर्मैट कर सकते हैं। नीचे साइन ब्लॉक जोड़ें। कोडिंग की ज़रूरत नहीं—सब क्लिक से।',
  'faq.previewWhenQ': 'भेजने से पहले कब प्रीव्यू करें?',
  'faq.previewWhenA': 'भेजने से पहले हमेशा PDF प्रीव्यू इस्तेमाल करें। यह सटीक लेआउट दिखाता है: समझौता टेक्स्ट, साइन ब्लॉक, तारीख, नाम। फॉर्मैट चेक करें फिर भेजें या लिंक कॉपी करें।',
  'faq.documentLifetimeQ': 'साइन लिंक कितने दिन चलते हैं? एक्सटेंशन माँग सकते हैं?',
  'faq.documentLifetimeA': 'साइन लिंक आम तौर पर लगभग 30 दिन सक्रिय रहते हैं। लिंक एक्सपायर होने से पहले साइन किया PDF डाउनलोड और सेव करें। अगर लिंक एक्सपायर हो गया तो भेजने वाले से नई ईमेल और फ्रेश लिंक माँगें।',
  'faq.editLayoutQ': 'साइन लेआउट कैसे एडिट करें?',
  'faq.editLayoutA': 'साइन सेक्शन में लेआउट एडिट इस्तेमाल करें। तारीख, पूरा नाम, टर्म्स, साइन ब्लॉक और कस्टम फ़ील्ड ड्रैग-ड्रॉप से व्यवस्थित करें। स्पेसर जोड़ें और कॉलम चुनें।',
  'faq.customFieldsQ': 'कस्टम फ़ील्ड (टेक्स्ट, डेट, चेकबॉक्स आदि) कैसे जोड़ें?',
  'faq.customFieldsA': 'साइन सेक्शन में कस्टम फ़ील्ड जोड़ें पर क्लिक करें। लेबल और टाइप चुनें: टेक्स्ट, नंबर, डेट, टाइम, पिकलिस्ट, चेकबॉक्स या साइन। प्रति दस्तावेज़ 10 तक। कौन से साइनर कौन सा फ़ील्ड देखें चुनें, फिर लेआउट एडिट से पोजिशन करें।',
  'faq.multipleSignaturesQ': '2 या ज़्यादा साइन (कई साइनर) जोड़ सकते हैं?',
  'faq.multipleSignaturesA': 'हाँ। रिसिपिएंट सेक्शन में दूसरा साइनर जोड़ें। हर कोई यूनीक लिंक और अपना साइन ब्लॉक पाता है। बेसिक: 5 तक; स्टैंडर्ड और प्रीमियम: 10 तक प्रति भेजा।',
  'faq.documentBuilderTipsQ': 'डॉक्यूमेंट बिल्डर में क्या कर सकते हैं?',
  'faq.documentBuilderTipsA': 'समझौते बनाएं, PDF अपलोड या एक्सट्रैक्ट करें, साइन ब्लॉक, कस्टम फ़ील्ड और अटैचमेंट जोड़ें। लेआउट एडिट करें, टेम्पलेट सेव करें, PDF प्रीव्यू करें। बदलाव ऑटो-सेव होते हैं।',
  'faq.clearEverythingQ': 'सब क्लियर करें क्या करता है?',
  'faq.clearEverythingA': 'सब क्लियर करें बिल्डर रिसेट करता है: समझौता टेक्स्ट, साइन ब्लॉक, कस्टम फ़ील्ड और अटैचमेंट हट जाते हैं। नया दस्तावेज़ शुरू करने के लिए इस्तेमाल करें। सेव किए टेम्पलेट पर असर नहीं।',
  'faq.forgotPasswordQ': 'पासवर्ड भूल गए। कैसे रिसेट करें?',
  'faq.forgotPasswordA': 'लॉगिन स्क्रीन पर पासवर्ड भूल गए? क्लिक करें। अकाउंट ईमेल डालें और रिसेट लिंक भेजें। इनबॉक्स (और स्पैम) चेक करें। लिंक एक्सपायर होता है—ज़रूरत हो तो नया माँगें। नए पासवर्ड से लॉगिन करें।',
  'faq.saveTemplateQ': 'दस्तावेज़ को टेम्पलेट के रूप में कैसे सेव करें?',
  'faq.saveTemplateA': 'दस्तावेज़ बनाएं, फिर टेम्पलेट सेव करें क्लिक करें। नाम दें और नया के रूप में सेव करें। मेरा खाता के टेम्पलेट इतिहास में दिखेगा। अपडेट के लिए: टेम्पलेट लोड करें, बदलाव करें, फिर टेम्पलेट सेव करें → टेम्पलेट अपडेट करें।',
  'faq.loadTemplateQ': 'टेम्पलेट इतिहास से टेम्पलेट कैसे लोड करें?',
  'faq.loadTemplateA': 'मेरा खाता → टेम्पलेट इतिहास। जो टेम्पलेट चाहिए उसे क्लिक करें। बिल्डर में पूरा कंटेंट और लेआउट के साथ खुलेगा। ज़रूरत हो तो एडिट करें, रिसिपिएंट जोड़ें और भेजें।',
  'faq.templateLimitsQ': 'कितने टेम्पलेट सेव कर सकते हैं?',
  'faq.templateLimitsA': 'बेसिक: 3, स्टैंडर्ड: 10, प्रीमियम: 25 टेम्पलेट। हर एक टेक्स्ट, फॉर्मैटिंग, साइन ब्लॉक और लेआउट सेव करता है। लिमिट पर: पुराना डिलीट करें या प्लान अपग्रेड करें।',
  'faq.recipientNoEmailQ': 'रिसिपिएंट को साइन ईमेल नहीं मिला तो?',
  'faq.recipientNoEmailA': 'स्पैम चेक करने को कहें। लिंक कॉपी करें से URL लें और मैन्युअल शेयर करें (टेक्स्ट, Slack आदि)। या उसी ईमेल पर दस्तावेज़ दोबारा भेजें—नया लिंक मिलेगा।',
  'faq.editAfterSendQ': 'भेजने के बाद दस्तावेज़ एडिट कर सकते हैं?',
  'faq.editAfterSendA': 'नहीं। भेजने के बाद कंटेंट लॉक हो जाता है। बदलाव के लिए: अपडेट के साथ नया दस्तावेज़ बनाएं और फिर भेजें। अनसेंट ड्राफ्ट फ्रीली एडिट हो सकते हैं।',
  'faq.changeAccountQ': 'अकाउंट ईमेल या पासवर्ड कैसे बदलें?',
  'faq.changeAccountA': 'मेरा खाता → खाता विवरण। ईमेल या पासवर्ड अपडेट करें। पासवर्ड के लिए: मौजूदा और नया डालें। मौजूदा याद न हो तो लॉगिन स्क्रीन पर पासवर्ड भूल गए? इस्तेमाल करें।',
  'faq.browserSupportQ': 'कौन से ब्राउज़र और डिवाइस सपोर्टेड हैं?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (डेस्कटॉप और मोबाइल)। रिस्पॉन्सिव साइनिंग—स्मार्टफोन और टैबलेट पर काम करता है। लेटेस्ट ब्राउज़र इस्तेमाल करें। ऐप डाउनलोड की ज़रूरत नहीं।',
  'faq.copyLinkQ': 'ईमेल की जगह शेयर के लिए लिंक कैसे कॉपी करें?',
  'faq.copyLinkA': 'दस्तावेज़ बनाने के बाद लिंक कॉपी करें क्लिक करें। URL कॉपी हो जाती है। मैसेज, ईमेल या Slack में पेस्ट करें। रिसिपिएंट हमारे ईमेल के बिना साइन कर सकते हैं।',
  'faq.resendDocumentQ': 'रिसिपिएंट ने अभी साइन नहीं किया तो दस्तावेज़ दोबारा भेज सकते हैं?',
  'faq.resendDocumentA': 'हाँ। उसी या दूसरे ईमेल पर दस्तावेज़ दोबारा भेज सकते हैं। हर भेजने पर नया लिंक बनता है। अगर पुराना लिंक एक्सपायर हो गया तो दोबारा भेजने से नया लिंक मिलेगा। ईमेल एक्टिविटी (प्रीमियम) से भेजने का स्टेटस देख सकते हैं।',
  'testimonials.eyebrow': 'ग्राहक कहते हैं',
  'testimonials.title': 'हमारे ग्राहक क्या कहते हैं।',
  'testimonials.quote1': 'लागत सबसे कम। सबसे अच्छा मूल्य और आसान उपयोग।',
  'testimonials.quote2': 'ChatGPT से समझौता पेस्ट किया, मिनटों में संपादित किया, साइन के लिए भेजा। 10 मिनट से कम।',
  'testimonials.quote3': 'पूरा काम फ़ोन से। दस्तावेज़ बनाया, साइन फ़ील्ड जोड़े, कम्यूट में भेजा।',
  'testimonials.quote4': 'आसान और निष्पक्ष कीमत। कोई छिपी फीस नहीं। टीम कॉन्ट्रैक्ट और NDA के लिए इस्तेमाल करती है।',
  'testimonials.quote5': 'कॉन्ट्रैक्ट टेक्स्ट पेस्ट किया, साइन ब्लॉक डाला, भेजा। उसी दिन साइन हो गया।',
  'testimonials.quote6': 'लैपटॉप और फ़ोन पर इस्तेमाल किया। दोनों पर स्मूद। ई-साइन के लिए सबसे अच्छा मूल्य।',
  'testimonials.prev': 'पिछला',
  'testimonials.next': 'अगला',
  'contact.title': 'संपर्क करें',
  'contact.subtitle': 'कोई सवाल? हम आपसे सुनना पसंद करेंगे।',
  'contact.eyebrow': 'संपर्क करें',
  'contact.headlineBefore': 'आइए ',
  'contact.headlineAccent': 'बात करें',
  'contact.responseTimeLabel': 'जवाब का समय',
  'contact.responseTimeValue': '24 घंटे के भीतर',
  'contact.secureLabel': 'सुरक्षित और निजी',
  'contact.secureValue': 'AES-256 एन्क्रिप्शन',
  'contact.trustNoSpam': 'कोई स्पैम नहीं, कभी नहीं',
  'contact.trustHumanSupport': 'असली इंसानी सहायता',
  'contact.firstName': 'पहला नाम',
  'contact.lastName': 'उपनाम',
  'contact.email': 'ईमेल',
  'contact.message': 'संदेश',
  'contact.sendMessage': 'संदेश भेजें',
  'contact.required': '*',
  'contact.placeholderFirst': 'अपना पहला नाम दर्ज करें',
  'contact.placeholderLast': 'अपना उपनाम दर्ज करें',
  'contact.placeholderEmail': 'अपना ईमेल दर्ज करें',
  'contact.placeholderMessage': 'बताएं हम कैसे मदद कर सकते हैं…',
  'contact.attachments': 'अटैचमेंट',
  'contact.attachmentsHint': '5 फ़ाइलें तक, 2 MB कुल',
  'contact.addFiles': '+ फ़ाइलें जोड़ें',
  'contact.addAttachmentsAria': 'अटैचमेंट जोड़ें',
  'auth.forgotPassword': 'पासवर्ड भूल गए?',
  'auth.backToLogIn': 'लॉग इन पर वापस',
  'auth.sendResetLink': 'रीसेट लिंक भेजें',
  'auth.checkEmailReset': 'रीसेट लिंक के लिए ईमेल देखें।',
  'auth.emailLabel': 'ईमेल',
  'auth.passwordLabel': 'पासवर्ड',
  'auth.firstNameLabel': 'पहला नाम',
  'auth.lastNameLabel': 'उपनाम',
  'auth.enterEmail': 'अपना ईमेल दर्ज करें।',
  'auth.enterEmailPassword': 'ईमेल और पासवर्ड दर्ज करें।',
  'auth.passwordMinLength': 'पासवर्ड कम से कम 8 अक्षर।',
  'auth.passwordSpecial': 'पासवर्ड में विशेष अक्षर होना चाहिए।',
  'auth.passwordsNoMatch': 'पासवर्ड मेल नहीं खाते।',
  'auth.signInWithGoogle': 'Google से लॉग इन करें',
  'auth.or': 'या',
  'auth.logInFailed': 'लॉग इन विफल।',
  'auth.signUpFailed': 'साइनअप विफल।',
  'auth.emailAlreadyInUse': 'यह ईमेल पहले से उपयोग में है।',
  'connectionError.message': 'कनेक्शन में समस्या। कृपया अपना इंटरनेट जांचें और पेज रिफ्रेश करें।',
  'connectionError.refresh': 'पेज रिफ्रेश करें',
  'connectionError.tooManyRequests': 'बहुत अधिक प्रयास। कृपया बाद में पुनः प्रयास करें।',
  'auth.emailPlaceholder': 'naam@udaharan.com',
  'auth.passwordPlaceholder': 'अपना पासवर्ड दर्ज करें',
  'auth.firstNamePlaceholder': 'राज',
  'auth.lastNamePlaceholder': 'कुमार',
  'auth.manageSubscription': 'सब्सक्रिप्शन प्रबंधित करें',
  'auth.subscribe': 'सब्सक्राइब करें',
  'auth.signUpForSubscription': 'सब्सक्रिप्शन के लिए साइन अप करें',
  'auth.currentPlan': 'वर्तमान प्लान',
  'auth.updatePlanHint': 'अधिक मासिक क्रेडिट के लिए Stripe में अपग्रेड करें।',
  'auth.updatePlanStripe': 'Stripe पोर्टल में प्लान, पेमेंट या रद्द करें।',
  'auth.subscribeToPlan': 'शुरू करने के लिए प्लान सब्सक्राइब करें।',
  'auth.topUpCredits': 'क्रेडिट खरीदें ({{label}}: ${{price}})',
  'pricing.featureRecipients5': 'प्रति भेजना 5 प्राप्तकर्ता तक',
  'pricing.featureRecipients10': 'प्रति भेजना 10 प्राप्तकर्ता तक',
  'pricing.featureEmails5': 'माह में 5 ईमेल तक',
  'pricing.featureEmails50': 'माह में 50 ईमेल तक',
  'pricing.featureEmails150': 'माह में 150 ईमेल तक',
  'pricing.featureTemplates3': '3 टेम्पलेट',
  'pricing.featureTemplates10': '10 टेम्पलेट',
  'pricing.featureTemplates25': '25 टेम्पलेट',
  'pricing.featureChars3k': '3,000 अक्षर सीमा',
  'pricing.featureChars20k': '20,000 अक्षर सीमा',
  'pricing.featureChars30k': '30,000 अक्षर सीमा',
  'pricing.featureAttachmentsNone': 'कोई अतिरिक्त अटैचमेंट नहीं',
  'pricing.featureAttachments3': '3 अटैचमेंट (8 MB कुल)',
  'pricing.featureAttachments10': '10 अटैचमेंट (8 MB कुल)',
  'pricing.featurePdfUpload': 'पूर्ण PDF अपलोड',
  'pricing.featureAuditTrail': 'पूर्ण ऑडिट ट्रेल',
  'pricing.featurePdfExtract': 'PDF टेक्स्ट एक्सट्रैक्ट और संपादित करें',
  'pricing.featureCustomFields': 'कस्टम फ़ील्ड और लेआउट बनाएं',
  'pricing.featureCopyLink': 'साइन लिंक कॉपी करें',
  'pricing.featureLogo': 'कस्टम लोगो अपलोड करें',
  'pricing.featureVerification': 'प्राप्तकर्ता सत्यापन',
  'app.createYourDocument': 'अपना दस्तावेज़ बनाएं',
  'app.backToApp': 'ऐप पर वापस',
  'app.backToMainSite': 'मुख्य साइट पर वापस',
  'app.backShort': 'वापस',
  'app.myAccount': 'मेरा खाता',
  'app.saveTemplate': 'टेम्पलेट सहेजें',
  'app.templatesUsed': 'उपयोग किए गए टेम्पलेट',
  'app.templatesUsedSaved': '{{count}} टेम्पलेट सहेजे गए',
  'app.startFromTemplate': 'टेम्पलेट से शुरू करें',
  'app.startFromTemplateHint': 'दस्तावेज़ भरने के लिए एक टेम्पलेट चुनें। चयन के बाद इसे संपादित कर सकते हैं।',
  'app.signedInAs': 'इस रूप में साइन इन',
  'app.sendCredits': 'भेजने के क्रेडिट',
  'app.freeSendBanner': 'आपके पास 1 मुफ्त ईमेल भेजने का अवसर है — दस्तावेज़ हस्ताक्षर के लिए भेजने के लिए इसका उपयोग करें। अधिक के लिए कभी भी सदस्यता लें।',
  'app.creditEqualsSend': '1 क्रेडिट = 1 ईमेल भेजना',
  'app.topUpCredits': 'क्रेडिट टॉप-अप',
  'app.emailSends': 'ईमेल भेजे',
  'app.signedAgreements': 'हस्ताक्षरित समझौते',
  'app.usedAfterAllowance': '(मासिक अनुमति के बाद)',
  'app.sendForSignature': 'हस्ताक्षर के लिए भेजें',
  'app.recipientsSection': 'भेजने के लिए',
  'app.fromNameOrg': 'भेजने वाले का नाम / संगठन',
  'app.fromNamePlaceholder': 'आपका नाम या संगठन',
  'app.fromEmail': 'भेजने वाला ईमेल',
  'app.fromEmailPlaceholder': 'भेजने वाला ईमेल पता',
  'app.recipientEmail': 'प्राप्तकर्ता ईमेल',
  'app.recipientHint': 'कॉमा से अलग, अधिकतम {{max}} प्राप्तकर्ता',
  'app.recipientPlaceholder': 'प्राप्तकर्ता ईमेल पता',
  'app.recipientTooltip': 'उदाहरण: a@b.com, c@d.com',
  'app.previewPdf': 'PDF प्रीव्यू',
  'app.clearEverything': 'सब क्लियर करें',
  'app.clearEverythingTitle': 'दस्तावेज़, प्राप्तकर्ता और ड्राफ्ट क्लियर करें',
  'app.copyLink': 'लिंक कॉपी करें',
  'app.copyLinkSubscribersOnly': 'लिंक कॉपी करें (सब्सक्राइबर के लिए)',
  'app.generatingLink': 'लिंक जनरेट हो रहा…',
  'app.sendEmail': 'ईमेल भेजें',
  'app.agreementText': 'समझौता पाठ',
  'app.uploadPdfExtract': 'टेक्स्ट निकालने के लिए PDF अपलोड करें',
  'app.fullPdfUpload': 'पूर्ण PDF अपलोड',
  'app.agreementPlaceholder': 'यहाँ क्लिक करके समझौता पाठ लिखें...',
  'app.attachments': 'अटैचमेंट',
  'app.attachmentsHint': 'अधिकतम 10 फाइल, कुल 8 MB।',
  'app.addAttachment': '+ अटैचमेंट जोड़ें',
  'app.signatureSection': 'हस्ताक्षर सेक्शन',
  'app.totalSignatures': 'कुल हस्ताक्षर',
  'app.createNewField': 'नया फ़ील्ड बनाएं',
  'app.addField': 'फ़ील्ड जोड़ें',
  'app.layout': 'लेआउट',
  'app.editLayout': 'लेआउट संपादित करें',
  'app.addFieldTooltip': 'नीचे साइन ब्लॉक में कस्टम फ़ील्ड जोड़ें (टेक्स्ट, तारीख, चेकबॉक्स, साइन)। अधिकतम {{max}} फ़ील्ड।',
  'app.date': 'तारीख',
  'app.datePlaceholder': 'yyyy/mm/dd',
  'app.termsConditions': 'नियम और शर्तें',
  'app.fullName': 'पूरा नाम',
  'app.fullNamePlaceholder': 'पूरा कानूनी नाम दर्ज करें',
  'app.signature': 'हस्ताक्षर',
  'app.clickToSign': 'साइन करने के लिए क्लिक करें',
  'app.termsAgree': 'मैं सभी नियम और शर्तों से सहमत हूँ।',
  'app.phone': 'फ़ोन',
  'app.phonePlaceholder': 'फ़ोन नंबर दर्ज करें',
  'app.enterFieldPlaceholder': '{{label}} दर्ज करें',
  'app.enterNumber': 'नंबर दर्ज करें',
  'app.selectOption': 'चुनें...',
  'app.noFields': 'कोई फ़ील्ड नहीं',
  'app.newDocument': 'नया दस्तावेज़',
  'app.templateLabel': 'टेम्पलेट: {{name}}',
  'app.forSubscribersOnly': 'सब्सक्राइबर के लिए',
  'app.emailCredits': 'ईमेल क्रेडिट',
  'app.creditHintDeliver': '1 क्रेडिट = 1 ईमेल — भेजने के लिए क्लिक करें',
  'app.skipAuthTesting': 'ऑथ स्किप करें (टेस्ट)',
  'app.agreementRequired': 'समझौता पाठ या PDF अपलोड ज़रूरी है।',
  'app.agreementOrPdfRequired': 'समझौता पाठ या PDF ज़रूरी है।',
  'app.loadingPdf': 'PDF लोड हो रहा…',
  'app.clearConfirmTitle': 'सब क्लियर करें',
  'app.clearConfirmMessage': 'क्या आप सभी फ़ील्ड और अटैचमेंट क्लियर करना चाहते हैं?',
  'app.cancel': 'रद्द करें',
  'app.clear': 'क्लियर',
  'app.clearConfirmButton': 'हाँ, सब क्लियर करें',
  'footer.tagline': 'आधुनिक यूज़र्स के लिए सुरक्षित ई-हस्ताक्षर।',
  'footer.product': 'उत्पाद',
  'footer.templates': 'टेम्पलेट',
  'footer.company': 'कंपनी',
  'footer.contactSupport': 'सपोर्ट',
  'footer.copyright': '© 2026 primedocumentsign. सर्वाधिकार सुरक्षित।',
  'footer.terms': 'सेवा की शर्तें',
  'footer.privacy': 'गोपनीयता नीति',
  'auth.logIn': 'लॉग इन',
  'auth.loggingIn': 'लॉग इन हो रहा है…',
  'auth.getStarted': 'शुरू करें',
  'auth.signUp': 'साइन अप',
  'auth.logInToManage': 'दस्तावेज़ प्रबंधित और साइन के लिए भेजने के लिए लॉग इन करें।',
  'auth.startSending': 'सरल सब्सक्रिप्शन प्लान से दस्तावेज़ भेजना शुरू करें।',
  'auth.termsConfirmStart': 'मैं पुष्टि करता/करती हूँ कि मैंने पढ़ लिया है और सहमत हूँ',
  'auth.termsConfirmEnd': '।',
  'auth.termsMustAccept': 'खाता बनाने के लिए कृपया सेवा की शर्तें स्वीकार करें।',
  'email.signSubject': 'कृपया इस समझौते पर हस्ताक्षर करें',
  'email.signTitle': 'हस्ताक्षर के लिए दस्तावेज़',
  'email.signSubtitle': 'आपसे एक दस्तावेज़ पर हस्ताक्षर करने के लिए कहा गया है',
  'email.fromLabel': 'भेजने वाला',
  'email.signBody': 'दस्तावेज़ खोलने और हस्ताक्षर जोड़ने के लिए नीचे दिए बटन पर क्लिक करें। किसी भी प्राप्तकर्ता को इस लिंक से पहुंच और हस्ताक्षर कर सकते हैं — खाता या सदस्यता की ज़रूरत नहीं।',
  'email.signButton': 'दस्तावेज़ पर हस्ताक्षर करें',
  'email.copyLink': 'या इस लिंक को कॉपी करें:',
  'email.ignoreNote': 'अगर आपको यह ईमेल नहीं मिलना चाहिए था तो इसे नज़रअंदाज़ कर सकते हैं।',
  'modal.editFieldLayout': 'फ़ील्ड लेआउट संपादित करें',
  'modal.editFieldLayoutHint': 'फ़ील्ड को कॉलम के बीच खींचकर क्रम बदलें या ले जाएं।',
  'modal.columns': 'कॉलम',
  'modal.col': '{{n}} कॉलम',
  'modal.addSpace': 'स्पेस जोड़ें',
  'modal.fields': 'फ़ील्ड',
  'modal.leftColumn': 'बाएं कॉलम',
  'modal.rightColumn': 'दाएं कॉलम',
  'modal.removeFromLayout': 'लेआउट से {{name}} हटाएं?',
  'modal.space': 'स्पेस',
  'modal.yesRemove': 'हाँ, हटाएं',
  'modal.keepIt': 'रखें',
  'modal.emptySpace': 'खाली जगह',
  'modal.dropFieldsHere': 'फ़ील्ड यहाँ ड्रॉप करें',
  'modal.removedFromLayout': 'लेआउट से हटाया — पुनर्स्थापित करने के लिए + क्लिक करें',
  'modal.saveLayout': 'लेआउट सहेजें',
  'modal.removeFromLayoutTitle': 'लेआउट से हटाएं',
  'modal.restoreToLayout': 'लेआउट में पुनर्स्थापित करें',
  'modal.editCustomField': 'कस्टम फ़ील्ड संपादित करें',
  'modal.editCustomFieldHint': 'लेबल, प्रकार या कौन से साइनर इस फ़ील्ड को देखें — बदलें।',
  'modal.addCustomField': 'कस्टम फ़ील्ड जोड़ें',
  'modal.addCustomFieldHint': 'साइनिंग फॉर्म में शामिल करने के लिए नया फ़ील्ड बनाएं। अधिकतम 10 कस्टम फ़ील्ड।',
  'modal.fieldLabel': 'फ़ील्ड लेबल',
  'modal.fieldLabelPlaceholder': 'जैसे कंपनी का नाम',
  'modal.fieldType': 'फ़ील्ड प्रकार',
  'modal.displayContent': 'डिस्प्ले कंटेंट (प्राप्तकर्ता के लिए केवल पढ़ने के लिए, अधिकतम 100 अक्षर)',
  'modal.displayContentPlaceholder': 'जैसे नीचे की शर्तें देखें',
  'modal.picklistOptions': 'पिकलिस्ट विकल्प (अधिकतम 10)',
  'modal.typeAndPressAdd': 'टाइप करें और जोड़ें दबाएं',
  'modal.add': 'जोड़ें',
  'modal.addedToSignature': 'हस्ताक्षर में जोड़ा गया',
  'modal.addedToSignatureHint': 'नया फ़ील्ड साइनचर लेआउट में जोड़ने के लिए नीचे चेक करें।',
  'modal.signature1': 'हस्ताक्षर 1',
  'modal.signature2': 'हस्ताक्षर 2',
  'modal.close': 'बंद करें',
  'modal.save': 'सहेजें',
  'modal.fieldLabelRequired': 'फ़ील्ड लेबल ज़रूरी है',
  'modal.displayContentRequired': 'टेक्स्ट डिस्प्ले के लिए डिस्प्ले कंटेंट ज़रूरी है',
  'modal.picklistOptionRequired': 'कम से कम एक पिकलिस्ट विकल्प जोड़ें',
  'modal.selectOneSignature': 'कम से कम एक हस्ताक्षर चुनें',
  'modal.signingSectionExceed': 'साइनिंग सेक्शन {{limit}} KB सीमा से अधिक हो जाएगा। पहले कुछ कंटेंट हटाएं।',
  'modal.link': 'लिंक',
  'modal.linkTitle': 'लिंक शीर्षक',
  'modal.linkUrl': 'लिंक URL',
  'modal.linkTextPlaceholder': 'लिंक टेक्स्ट',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': 'समझौता आकार सीमा पूरी',
  'modal.characterLimitReached': 'वर्ण सीमा पूरी',
  'modal.agreementSizeLimitMessage': 'अधिकतम समझौता आकार ({{max}} KB) पूरा। और जोड़ने से पहले कंटेंट या इमेज हटाएं।',
  'modal.characterLimitMessage': 'अधिकतम वर्ण सीमा ({{max}}) पूरी। और जोड़ने से पहले टेक्स्ट हटाएं।',
  'modal.signingSectionLimitReached': 'साइनिंग सेक्शन सीमा पूरी',
  'modal.signingSectionLimitMessage': 'अधिकतम साइनिंग सेक्शन आकार ({{limit}} KB) पूरा। फ़ील्ड वैल्यू, हस्ताक्षर या कस्टम फ़ील्ड हटाएं।',
  'modal.ok': 'ठीक है',
  'modal.addYourSignature': 'अपना हस्ताक्षर जोड़ें',
  'modal.signatureHint': 'साइन करने के लिए माउस या ट्रैकपैड इस्तेमाल करें।',
  'modal.clear': 'क्लियर',
  'modal.saveSignature': 'हस्ताक्षर सहेजें',
  'modal.removeAttachment': 'अटैचमेंट हटाएं',
  'modal.removeAttachmentConfirm': 'क्या आप "{{name}}" को इस दस्तावेज़ से हटाना चाहते हैं?',
  'modal.yesRemoveLabel': 'हाँ, हटाएं',
  'modal.removeLogo': 'लोगो हटाएं',
  'modal.removeLogoConfirm': 'क्या आप इस दस्तावेज़ से अपना लोगो हटाना चाहते हैं?',
  'modal.textDisplay': 'टेक्स्ट डिस्प्ले',
  'modal.picklist': 'पिकलिस्ट',
  'modal.number': 'नंबर',
  'modal.time': 'समय',
  'modal.editLabel': 'लेबल संपादित करें',
  'modal.editField': 'फ़ील्ड संपादित करें',
  'modal.text': 'टेक्स्ट',
  'modal.checkbox': 'चेकबॉक्स',
  'modal.date': 'तारीख',
  'modal.signature': 'हस्ताक्षर',
  'modal.typeHasDataHint': 'इस फ़ील्ड में पहले से डेटा है इसलिए प्रकार बदला नहीं जा सकता।',
  'modal.typeHasDataTitle': 'जब फ़ील्ड में डेटा हो तो प्रकार नहीं बदला जा सकता',
  'modal.noKeepIt': 'नहीं, रखें',
  'modal.yesDelete': 'हाँ, डिलीट करें',
  'modal.deleteTemplate': 'टेम्पलेट डिलीट करें',
  'modal.deleteTemplateConfirm': 'क्या आप "{{name}}" को डिलीट करना चाहते हैं? यह पूर्ववत नहीं हो सकता।',
  'modal.removeAttachmentFromMessage': 'क्या आप "{{name}}" को अपने मैसेज से हटाना चाहते हैं?',
  'modal.readyToSend': 'भेजने के लिए तैयार?',
  'modal.recipientsLabel': 'प्राप्तकर्ता:',
  'modal.readyToSendSubtitle': 'क्या आपने दस्तावेज़ प्रीव्यू किया और भेजने के लिए तैयार हैं? निम्नलिखित प्राप्तकर्ता को यह ईमेल मिलेगा:',
  'modal.no': 'नहीं',
  'modal.yesSend': 'हाँ, भेजें',
  'modal.accountAlreadyExists': 'खाता पहले से मौजूद है',
  'modal.accountAlreadyExistsMessage': 'यह ईमेल पहले से रजिस्टर है। क्या आप लॉग इन करना चाहेंगे या दूसरे ईमेल से साइन अप?',
  'modal.useDifferentEmail': 'दूसरा ईमेल इस्तेमाल करें',
  'modal.logIn': 'लॉग इन',
  'modal.logOut': 'लॉग आउट करें?',
  'modal.logOutSubtitle': 'क्या आप लॉग आउट करना चाहते हैं?',
  'modal.yesLogOut': 'हाँ, लॉग आउट',
  'lang.en': 'अंग्रेज़ी',
  'lang.es': 'स्पेनिश',
  'lang.pt': 'पुर्तगाली',
  'lang.ja': 'जापानी',
  'lang.zh': 'चीनी',
  'lang.hi': 'हिंदी',
  'lang.fr': 'फ्रेंच',
  'lang.it': 'इतालवी',
  'lang.de': 'जर्मन',

  'templates.starter.nda.name': 'गोपनीयता समझौता (NDA)',
  'templates.starter.nda.scopeTitle': 'गोपनीयता समझौता',
  'templates.starter.freelance.name': 'फ्रीलांस सेवा समझौता',
  'templates.starter.freelance.scopeTitle': 'फ्रीलांस सेवा समझौता',
  'templates.starter.vehicle.name': 'वाहन बिक्री समझौता',
  'templates.starter.vehicle.scopeTitle': 'वाहन बिक्री समझौता',
  'templates.starter.rental.name': 'आवासीय किराया समझौता',
  'templates.starter.rental.scopeTitle': 'आवासीय किराया समझौता',
  'templates.starter.recruitment.name': 'भर्ती सेवा समझौता',
  'templates.starter.recruitment.scopeTitle': 'भर्ती सेवा समझौता',
  'templates.starter.loan.name': 'ऋण समझौता',
  'templates.starter.loan.scopeTitle': 'ऋण समझौता',
  'templates.starter.website.name': 'वेबसाइट विकास समझौता',
  'templates.starter.website.scopeTitle': 'वेबसाइट विकास समझौता',
  'templates.starter.roommate.name': 'रूममेट समझौता',
  'templates.starter.roommate.scopeTitle': 'रूममेट समझौता',
  'templates.starter.photography.name': 'फोटोग्राफी सेवा समझौता',
  'templates.starter.photography.scopeTitle': 'फोटोग्राफी सेवा समझौता',
  'templates.starter.shortterm-rental.name': 'अल्पकालिक किराया समझौता',
  'templates.starter.shortterm-rental.scopeTitle': 'अल्पकालिक किराया समझौता',
  'templates.starter.equipment-rental.name': 'उपकरण किराया समझौता',
  'templates.starter.equipment-rental.scopeTitle': 'उपकरण किराया समझौता',
  'templates.starter.independent-contractor.name': 'स्वतंत्र ठेकेदार समझौता',
  'templates.starter.independent-contractor.scopeTitle': 'स्वतंत्र ठेकेदार समझौता',
}
